import { EResourceCrud } from "@project/shared-types";
import { makeCrudDataProvider } from "./dataProvider";

export const bansProvider = makeCrudDataProvider({
  resource: EResourceCrud.BANS,
});

export const usersProvider = makeCrudDataProvider({
  resource: EResourceCrud.USERS,
});

export const ordersProvider = makeCrudDataProvider({
  resource: EResourceCrud.ORDERS,
});

export const articlesProvider = makeCrudDataProvider({
  resource: EResourceCrud.ARTICLES,
});

export const categoriesProvider = makeCrudDataProvider({
  resource: EResourceCrud.CATEGORIES,
});

export const ticketsProvider = makeCrudDataProvider({
  resource: EResourceCrud.TICKETS,
});

export const jobsProvider = makeCrudDataProvider({
  resource: EResourceCrud.JOBS,
});

export const worksProvider = makeCrudDataProvider({
  resource: EResourceCrud.WORKS,
});
export const operationsProvider = makeCrudDataProvider({
  resource: EResourceCrud.OPERATIONS,
});
export const feedbackProvider = makeCrudDataProvider({
  resource: EResourceCrud.FEEDBACK,
});
